import createModule from "../createModule"
import view from "./view"
import { Creators } from "./model"
import { Creators as PortfolioRootCreators } from "modules/portfolio-root/model"
import { Creators as DialogCreators } from "modules/dialog/model"
import { getViewType, getPeriod, getPortfolioId, getSelectedModelId, getIsExpanded, getIsActive, getCurrency, getPortfolioFxHedgeEnabled } from "modules/portfolio-root/selectors/portfolios"
import { getEarliestDate, getLatestDate } from "modules/portfolio-root/selectors/dates"
import { getFetchStartDate, getEndDate, getSelectedDate, getAiSummaryStartDate } from "selectors/dates"
import { Creators as notificationsCreators } from "modules/notifications/model"
import { getSegment } from "modules/analyze-header/selectors/segment"
import { getFiltersVisible } from "modules/analyze-header/selectors"
import { getBaseSignature, getBasePositionSetWithSegment } from "selectors/base"
import { getDisplayAddView, getSelectedViews } from "selectors/factors"
import { getStyleAggregation } from "selectors/styleAggregation"
import { getFactorSensitivityQueryParams } from "helpers/factorSensitivity"
import { getOptions, getSelectedOption, getFilteredData, getCategoryItemsSubset, getPassthroughResourcesStatus } from "./selectors/data"
import { getDisplayType, getDisplayTypeName, getAvailableSelectViewFactors, getDisplayAggregationToggle } from "./selectors/items"
import { getFileName } from "./selectors/file"
import { getDatesAdjusted } from "./selectors/dates"
import { getFirstFactorSensitivityDate } from "./selectors/sensitivity"
import { getFactorSensitivityType, getThresholdParams } from "selectors/factorSensitivity"
import { getIsOpPro } from "modules/account-root/selectors"
import withUrlParams from "hocs/withUrlParams"
import { MODEL_METADATA_QUERY } from "resources/models"

export default withUrlParams(createModule({
  view,
  externalProps: (state, props) => ({
    portfolio: state.global.selected.portfolio,
    portfolioId: getPortfolioId(state, props),
    account: state.global.selected.account,
    accountId: state.global.selected.accountId,
    modelId: getSelectedModelId(state, props),
    startDate: getFetchStartDate(state, props),
    aiSummaryStartDate: getAiSummaryStartDate(state, props),
    endDate: getEndDate(state, props),
    selectedDate: getSelectedDate(state, props),
    viewType: getViewType(state, props),
    base: getBasePositionSetWithSegment(state, props),
    baseSignature: getBaseSignature(state, props),
    segment: getSegment(state, props),
    expand: getIsExpanded(state, props),
    isActive: getIsActive(state, props),
    currency: getCurrency(state, props),
    factorSensitivityType: getFactorSensitivityType(state, props),
    isStyleFactorsAdditive: false,
    fxHedgeEnabled: getPortfolioFxHedgeEnabled(state, props),
  }),
  required: ["account", "portfolio", "modelId"],
  data: [{
    resource: "portfolio",
    as: null,
    url: ({ account, portfolio }) => `/api/${account}/p/${portfolio}`,
  }, {
    resource: "factorSensitivity",
    as: null,
    passthrough: true,
    url: ({ portfolioId, modelId, isActive, startDate, endDate, base, baseSignature, expand, segment, factorSensitivityType, currency, fxHedgeEnabled }) => {
      return {
        id: `factorSensitivity-${factorSensitivityType}${modelId}${portfolioId}${startDate}${endDate}${isActive}${baseSignature}${JSON.stringify(segment)}${expand}${currency}${fxHedgeEnabled}`,
        query: `query ($modelId: String!, $positionSet: PositionSetInput!, $startDate: Date!, $endDate: Date!, $base: [PositionSetInput], $factorSensitivityType: FactorSensitivityType!, $stdDev: PositiveFloat, $days: PositiveInt, $horizon: FactorSensitivityTimeHorizon!) {
          model (id: $modelId) {
            simulation (positionSet: $positionSet, from: $startDate, to: $endDate, base: $base, interval: AUTO) {
              factorSensitivity (type: $factorSensitivityType horizon: $horizon stdDev: $stdDev days: $days) {
                date
                factors {
                  id
                  name
                  category
                  sensitivity
                }
              }
            }
          }
        }`,
        variables: {
          modelId,
          positionSet: {
            type: "PORTFOLIO",
            id: portfolioId,
            segment,
            expand,
          },
          startDate,
          endDate,
          ...getFactorSensitivityQueryParams(factorSensitivityType),
          base: isActive ? [base] : undefined,
        },
      }
    },
  },
  MODEL_METADATA_QUERY,
  ],
  mapStateToProps: (state, props) => ({
    ...state.modules.analyzeFactorSensitivity,
    earliestDate: getEarliestDate(state, props),
    latestDate: getLatestDate(state, props),
    data: getFilteredData(state, props),
    items: getCategoryItemsSubset(state, props),
    options: getOptions(state, props),
    period: getPeriod(state, props),
    firstDate: getFirstFactorSensitivityDate(state, props),
    fileName: getFileName(state, props),
    displayType: getDisplayType(state, props),
    displayTypeName: getDisplayTypeName(state, props),
    selectedOption: getSelectedOption(state, props),
    filtersVisible: getFiltersVisible(state, props),
    datesAdjusted: getDatesAdjusted(state, props),
    selectedView: getSelectedViews(state, props),
    displayAddView: getDisplayAddView(state, props),
    availableSelectViewFactors: getAvailableSelectViewFactors(state, props),
    ...getStyleAggregation(state, props),
    displayAggregationToggle: getDisplayAggregationToggle(state, props),
    thresholdParams: getThresholdParams(state, props),
    isOpPro: getIsOpPro(state, props),
    passthroughResourcesStatus: getPassthroughResourcesStatus(state, props),
  }),
  actions: {
    ...Creators,
    setDate: PortfolioRootCreators.setDate,
    resetDate: PortfolioRootCreators.resetDate,
    setPeriod: PortfolioRootCreators.setPeriod,
    addSelectedView: PortfolioRootCreators.addSelectedView,
    removeSelectedView: PortfolioRootCreators.removeSelectedView,
    addNotification: notificationsCreators.add,
    openDialog: DialogCreators.open,
    setAggregationFn: PortfolioRootCreators.setAggregationFn,
  },
}))
